import moment from "moment/moment";
import momentTimezone from "moment-timezone";

export const utcDateAndTimeStringToLocalDate = (utcDate: string): string => {
  const date = new Date(utcDate);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export const convertDateToIsoFormat = (date: Date) => {
  const tempDate: string = moment(date).format("yyyy-MM-DDTHH:mm:ssZ");
  const dateFront: string = tempDate.split("T")[0];
  const dateBack: string = tempDate.split("+")[1];
  return dateFront + "T" + "00:00:00+" + dateBack;
}

export const formatUTCDateToJST = (dateTime: string | Date): string => {
  if (!dateTime) {
    return "";
  }
  return new Date(dateTime).toLocaleString("ja-JP", {
    timeZone: "Asia/Tokyo",
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  });
}

export const getFormattedDateTime = (
  dateTime: any,
  mode: string | null,
  lessonId: string | null
): string => {
  if (!mode && !lessonId) {
    // Create lesson: /lessons/preview
    return `${dateTime.formated.replace(/-/g, '/')} (JST)`;
  } else if (!mode && lessonId) {
    // View existing lesson: /lessons/preview?id=xx
    return `${formatUTCDateToJST(dateTime.formated)} (JST)`;
  } else if (mode === "save") {
    // After edit lesson: /lessons/preview?editStatus=save
    return `${dateTime.formated.replace(/-/g, '/')} (JST)`;
  } else if (mode === "view") {
    // View before edit lesson: /lessons/preview?id=79&editStatus=view
    return `${formatUTCDateToJST(dateTime.formated)} (JST)`;
  }
  return `${formatUTCDateToJST(dateTime.formated)} (JST)`; // Fallback
};
